/* js/profileBox.js */

jQuery( document ).ready(function( $ ) {

    $('.js-profileBox__quote-trigger').click(function (e) {
        e.preventDefault();
        $(this).closest('.profileBox').toggleClass('profileBox__quote-active');


        var txt = $(".js-profileBox__quote-full").is(':visible') ? 'Less' : 'More';
        $(".js-profileBox__quote-trigger").text(txt);



    });

});